"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M17 4v18H7V4h3V2h4v2zm-2 2H9v2h6z"
}), 'Battery6BarSharp');